export { LANG_DATA } from './lang-data';
